import React from 'react';
import { StyleInupt, StyleSlider } from '../components/common';
import { TopicStyles } from '../mixins/mixins';

export const MyFocusStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleSlider
				key={'greetings_size-range'}
				id={'greetings_size-range'}
				name={'Size'}
				initialValue={style.focusStyle?.size}
				minValue={'30'}
				maxValue={'65'}
				step={'5'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						focusStyle: { ...style.focusStyle, ['size']: value }
					});
				}}
			/>

			<StyleInupt
				key={'my_focus_input'}
				name={'My focus'}
				placeholder="User's focus"
				optionState={style.focusStyle?.myFocus}
				handleChange={(value: any) => {
					setStyle({
						...style,
						focusStyle: { ...style.focusStyle, ['myFocus']: value }
					});
				}}
			/>
		</div>
	);
};
